export * from "modules/DealerLocationDetails/components/General/components/CompanyStampUpload";
